import React from "react";
import { green, orange, grey } from "@mui/material/colors";
import Radio from "@mui/material/Radio";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import { useTranslation } from "react-i18next";
import LightTooltip from "../../../Components/LightTooltip";

export const noteColors = {
  purple: "#8d5ab5",
  blue: "#2196f3",
  green: green[500],
  orange: orange[500],
  grey: grey[500],
};

export default function RadioButtons(props) {
  const { t } = useTranslation();

  const handleChange = (event) => {
    props.setSelectedColorValue(event.target.value);
  };

  return (
    <div>
      {Object.keys(noteColors).map((color) => (
        <LightTooltip
          key={"Tooltip" + color}
          title={t(`common.placeholders.${color}`)}
        >
          <Radio
            checked={props.selectedColorValue === color}
            icon={<Brightness1Icon style={{ color: noteColors[color] }} />}
            checkedIcon={
              <CheckCircleIcon style={{ color: noteColors[color] }} />
            }
            onChange={handleChange}
            value={color}
            name="radio-button-demo"
            inputProps={{ "aria-label": color }}
            color={"default"}
            style={{ color: noteColors[color], backgroundColor: "transparent" }}
          />
        </LightTooltip>
      ))}
    </div>
  );
}
